/**
 * KAN-862: выбор этапа для карточки доски на телефоне (перетаскивание пальцем
 * мешает листать колонки): панель снизу с кнопками этапов по order, текущий
 * этап отмечен и недоступен.
 */
import { Check } from 'lucide-react';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';
import { sameStage, sortStages } from '@/lib/crmPipeline';
import { cn } from '@/lib/utils';
import type { CrmPipelineCard, CrmPipelineStage, CrmStageId } from '@/types/crmPipeline';

interface StagePickerProps {
  card: CrmPipelineCard | null;
  stages: readonly CrmPipelineStage[];
  onSelect: (card: CrmPipelineCard, stageId: CrmStageId) => void;
  onClose: () => void;
}

export function StagePicker({ card, stages, onSelect, onClose }: StagePickerProps): JSX.Element {
  return (
    <Sheet open={card !== null} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="bottom" className="max-h-[80dvh] overflow-y-auto rounded-t-2xl px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-5">
        <SheetTitle className="text-base">Сменить этап</SheetTitle>
        <SheetDescription className="truncate">{card?.name}</SheetDescription>
        <ul className="mt-3 space-y-1">
          {sortStages(stages).map((stage) => {
            const current = sameStage(card?.stage_id, stage.id);
            return (
              <li key={String(stage.id)}>
                <button
                  type="button"
                  disabled={current}
                  aria-current={current ? 'true' : undefined}
                  onClick={() => card && onSelect(card, stage.id)}
                  className={cn(
                    'flex min-h-[48px] w-full items-center justify-between rounded-xl px-4 text-left text-base',
                    current ? 'bg-blue-50 font-medium text-blue-700' : 'text-gray-900 active:bg-gray-100'
                  )}
                >
                  <span className="truncate">{stage.name}</span>
                  {current && <Check className="h-5 w-5 shrink-0" aria-hidden="true" />}
                </button>
              </li>
            );
          })}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
